var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTicketDebit = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 281.6 162.3"
  },
  viewBox: "0 0 281.6 162.3",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#2d2729}.st1{fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st2{fill:#fff}.st3{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.st3,.st4,.st5{fill:none;stroke:#000}.st4{stroke-width:1.5;stroke-miterlimit:10}.st5{stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:7.5407,7.5407}.st6{fill:#191a1a}.st7{fill:#9d9d9d}.st9{fill:#f4f4f4}.st10,.st11,.st12{stroke-miterlimit:10}.st10{stroke:#000;stroke-width:1.5}.st11,.st12{fill:none;stroke:#070707}.st12{stroke:#000;stroke-width:2}.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#0f0f08}")), /*#__PURE__*/React.createElement("path", {
  d: "M36.1 146.6h193.1c2.8 0 5.1-2.3 5.1-5.1V15c0-2.8-2.3-5.1-5.1-5.1H36.1c-2.8 0-5.1 2.3-5.1 5.1v126.5c.1 2.8 2.3 5.1 5.1 5.1z",
  style: {
    stroke: "#000",
    strokeMiterlimit: 10
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape-2_00000173132432828252494620000012942883422780039075_",
  d: "M168.3 81.5h-14.2c.5 3.1 3.5 4.3 6 4.3 1.6 0 3-.4 4.4-1l-.4 4.2c-1.6.6-3.5.9-5.4.9-6.3 0-10.7-3.7-10.7-10 0-5.4 4-9.5 10.1-9.5 6.9 0 10.3 4.4 10.2 11.1zm-25.7 8.1c-.3-.7-.7-1.8-1.1-2.9l-.8-2.8c-.4-1.5-1-2.1-2.4-2.1h-2.4v7.7h-5.5V64.3h5.5v13.9h.6l5.2-7.4h6.1l-6.1 7.7h.3c2.4 0 3.2 1.4 3.8 3.4l1 3.5c.4 1.3 1.1 3.1 1.7 4.2h-5.9zm-17.5-4.2c1.4 0 2.6-.4 3.5-.8l-.5 4.6c-1.1.6-2.8.9-4.2.9-5.9 0-10-3.8-10-9.8 0-5.9 4-9.7 10-9.7 2.2 0 3.9.4 5.6 1.2l-1.6 4.2c-.8-.5-2-.9-3.2-.9-3 0-5 2-5 5.2 0 3 2.1 5.1 5.4 5.1zm-18.5-17h5.6v-4.1h-5.6v4.1zm0 21.2h5.6V70.8h-5.6v18.8zm62.9-10.2V66.7l5.6-2.3v6.7h3.8l-.8 4.2H175v4.3c0 4.2 1.6 7.1 3.3 9.5.8-3.5 1.3-7.1 1.3-10.9 0-25.9-21-46.8-46.8-46.8-21 0-38.8 13.8-44.7 32.9h17.4l-.7 5h-7.3v20.3h-5.9V69.3h-4.8c-.6 2.9-.9 5.9-.9 8.9 0 25.9 21 46.8 46.8 46.8 21.9 0 40.4-15.1 45.4-35.5h-5.5c-1-1.6-3.2-4.7-3.1-10.1zm-11.2-5.1c-2.4 0-3.9 1.5-4.3 3.6h8.4c-.3-2.3-1.9-3.6-4.1-3.6",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTicketDebit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconTicketDebit.6cffb186.svg";
export { ForwardRef as ReactComponent };